var map = {
	"./AudioPlayer.js": 46,
	"./AutoplayVideo.js": 47,
	"./Featured.js": 48,
	"./FeaturedController.js": 51,
	"./Header.js": 52,
	"./HeroFrontpage.js": 54,
	"./HeroWithBox.js": 55,
	"./Menu.js": 56,
	"./NewsletterForm.js": 57,
	"./Parallaxer.js": 65,
	"./PoemsList.js": 66,
	"./PreviewVideo.js": 67,
	"./Quote.js": 68,
	"./ScrollToTarget.js": 69,
	"./Search.js": 70,
	"./Slider.js": 71,
	"./Slideshow.js": 83,
	"./Video.js": 84,
	"./VideoEmbed.js": 85,
	"./VideoLoop.js": 88
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45;


//////////////////
// WEBPACK FOOTER
// ./src/js/components \.js$
// module id = 45
// module chunks = 1